/**
 * Centralized query key factory.
 *
 * Using a factory prevents key typos across hooks and makes cache
 * invalidation predictable. Every key is an array to leverage
 * TanStack Query's hierarchical invalidation:
 *
 *   queryClient.invalidateQueries({ queryKey: queryKeys.jobs.all })
 *   // ↑ invalidates all job-related queries, including details
 *
 * When adding new domains, follow the existing pattern:
 *   domainName: {
 *     all: ["domainName"],
 *     detail: (id) => ["domainName", id],
 *   }
 */
export const queryKeys = {
  jobs: {
    all: ["jobs"],
    detail: (id) => ["jobs", id],
  },
  workflows: {
    all: ["workflows"],
    detail: (id) => ["workflows", id],
  },
  ncbi: {
    all: ["ncbi"],
  },
  results: {
    report: (jobId) => ["results", jobId, "report"],
  },
  user: {
    me: ["user", "me"],
    dashboard: ["user", "dashboard"],
  },
  sraCatalog: {
    all: ["sraCatalog"],
    studies: (params) => ["sraCatalog", "studies", params],
    runs: (params) => ["sraCatalog", "runs", params],
    studyDetail: (accession) => ["sraCatalog", "study", accession],
  },
};
